<template>
  <div class="content_container">페이지를 찾을 수 없습니다.</div>
</template>

<script>
export default {};
</script>

<style>
</style>